// Shared UI-only language hook for GamesNFans nav/buttons/footer.
// Persists to localStorage key 'games_lang'. Default 'en'. Article/body content is
// NOT translated — this only swaps chrome strings (nav labels, footer labels, etc.)
// via the LANG_LABELS dictionary in i18n.js.
import { useState, useEffect, useCallback } from 'react';

const STORAGE_KEY = 'games_lang';
const EVENT_NAME = 'gamesLangChange';
export const LANGUAGES = [
  { code: 'en', label: 'English' },
  { code: 'hi', label: 'हिन्दी' },
  { code: 'es', label: 'Español' },
  { code: 'fr', label: 'Français' },
  { code: 'ar', label: 'العربية' },
];

function getInitialLang() {
  if (typeof window === 'undefined') return 'en';
  try {
    const saved = window.localStorage.getItem(STORAGE_KEY);
    if (LANGUAGES.some((l) => l.code === saved)) return saved;
  } catch (e) { /* ignore */ }
  return 'en';
}

export function useGamesLanguage() {
  const [lang, setLangState] = useState(getInitialLang);

  useEffect(() => {
    const onChange = (e) => setLangState(e.detail);
    window.addEventListener(EVENT_NAME, onChange);
    return () => window.removeEventListener(EVENT_NAME, onChange);
  }, []);

  const setLang = useCallback((code) => {
    setLangState(code);
    try { window.localStorage.setItem(STORAGE_KEY, code); } catch (e) { /* ignore */ }
    window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: code }));
  }, []);

  return { lang, setLang };
}
